'use client'

import { type FC, type PropsWithChildren, useMemo, useState } from 'react'

import { useOpenableControls } from '../../../../generic-hooks'
import { SellerModal } from '../SellerModal'
import {
  SellerModalContext,
  type SellerModalContextValue,
} from '../SellerModalContext'

export const SellerModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const openableControls = useOpenableControls()

  const [productUpid, setProductUpid] = useState<string>('')
  const [sellerId, setSellerId] = useState<string>('')

  const contextValue: SellerModalContextValue = useMemo(
    (): SellerModalContextValue => ({
      openableControls,
      productUpid,
      sellerId,
      showSellerModal: (parameters): void => {
        setProductUpid(parameters.productUpid)
        setSellerId(parameters.sellerId)
        openableControls.handleOpen()
      },
    }),
    [openableControls, productUpid, sellerId],
  )

  return (
    <SellerModalContext.Provider value={contextValue}>
      {children}
      {Boolean(productUpid) && Boolean(sellerId) && (
        <SellerModal openableControls={openableControls} />
      )}
    </SellerModalContext.Provider>
  )
}
